import { useState } from "react";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import { Box, Container } from "@mui/material";

import CustomAppBar from "../../components/AppBar";
import GenericButton from "../../components/Custom/GenericButton";
import ActiveCampaigns from "./ActiveCampaigns";
import RegisteredCampaigns from "./RegisteredCampaigns";

const UserCampaigns = () => {
  const { t } = useTranslation();
  const [view, setView] = useState("Active");

  const buttonStyles = (currentView) => ({
    backgroundColor: view === currentView ? "#4CAF50" : "white",
    fontColor: view === currentView ? "white" : "black",
    borderColor: view === currentView ? "#388E3C" : "#A5A5A5",
    padding: "8px 20px",
    fontSize: "14px",
    hideIcon: true,
  });

  // if authenticated an auth object is present in the local storage
  const isAuthenticated = Boolean(localStorage.getItem("auth"));

  return (
    <>
      <Helmet>
        <title>Campaigns - Farmapp</title>
      </Helmet>
      {isAuthenticated && <CustomAppBar />}
      <Container maxWidth="xs">
        <Box
          display="flex"
          justifyContent="space-between"
          mt={2}
          sx={{
            backgroundColor: "white",
            padding: "0 10px",
            border: "1px solid #A5A5A5",
            borderRadius: "4px",
          }}
        >
          <Box flex="1" mr={1}>
            <GenericButton
              onClick={() => setView("Active")}
              {...buttonStyles("Active")}
            >
              {t("All Campaigns")}
            </GenericButton>
          </Box>
          <Box flex="1" ml={1}>
            <GenericButton
              onClick={() => setView("registered")}
              {...buttonStyles("registered")}
            >
              {t("Registered")}
            </GenericButton>
          </Box>
        </Box>
        <Box mt={2}>
          {view === "Active" ? <ActiveCampaigns /> : <RegisteredCampaigns />}
        </Box>
      </Container>
    </>
  );
};

export default UserCampaigns;
